module.exports = __webpack_public_path__ + "img/3.ed8a8e94.png";